/**
 * Checks if user name provided is valid
 */

export default function validateUserName(name: string): boolean {
    const regex = /^[a-zA-Z ]+$/
    return (name.trim().length >= 3) && regex.test(name)
}
